import React from "react";
import Header from "../components/header/Header";
import PostForm from "../components/forms/PostForm";
import Footer from "../components/footer/Footer";
const Post = () => {
  return (
    <div>
        <Header/>
        <PostForm/>
        <Footer/>
    </div>
  )
};

export default Post;
